import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';


import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styles: [
  ]
})
export class CreateUserComponent {

  public registerForm = this.fb.group({
    name: ['', Validators.required],
    surname: ['', Validators.required],
    email: ['', Validators.email],
    password: ['', Validators.required],
    role: ['', Validators.required],
    phone:[''],
    profession:[''],
    notes:[''],
    remainingTests:[0],
    country:[''],
    city:['']

  });

  constructor( private fb:FormBuilder, private userService: UserService) {}

  register(){
    this.userService.register(this.registerForm.value).subscribe(
      res=>{
        Swal.fire('Usuario creado',"", 'success');
        this.registerForm.reset();
      },
      err=>{
        Swal.fire('Error',err.error, 'error');
        this.registerForm.reset();
      }
    )
  }

  reset(){
    this.registerForm.reset();
  }


}
